import { motion } from "motion/react";
import type { ReactNode } from "react";

import { FADE_TRANSITION, PLACEHOLDER_DELAY_S } from "../constants";

type DelayedPlaceholderProps = {
  children: ReactNode;
  className?: string;
};

export function DelayedPlaceholder({
  children,
  className,
}: DelayedPlaceholderProps) {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ ...FADE_TRANSITION, delay: PLACEHOLDER_DELAY_S }}
      className={className}
      aria-busy
    >
      {children}
    </motion.div>
  );
}
